const QUERY_PARAMS = ['code', 'state'];
// The SSO entry point reads a bearer token or, for the PDF renderer of an /oidc
// session, a login assertion from the fragment (App.js).
const HASH_PARAMS = ['access_token', 'id_token', 'login_assertion'];

const redactParams = (params, keys) => {
  const matched = keys.filter((key) => params.has(key));
  matched.forEach((key) => params.set(key, 'redacted'));
  return matched.length > 0;
};

// The OIDC callback URL carries a one-time `code` and `state`, which must not
// reach Sentry through event URLs or navigation breadcrumbs.
export const redactAuthParams = (url) => {
  let parsed;
  try {
    parsed = new URL(url, window.location.origin);
  } catch {
    return url;
  }

  const queryMatched = redactParams(parsed.searchParams, QUERY_PARAMS);
  const hashParams = new URLSearchParams(parsed.hash.slice(1));
  const hashMatched = redactParams(hashParams, HASH_PARAMS);
  if (hashMatched) parsed.hash = `#${hashParams.toString()}`;
  if (!queryMatched && !hashMatched) return url;

  // Keep the input's form: absolute stays absolute, relative stays relative.
  if (/^[a-z][a-z\d+.-]*:/i.test(url)) return parsed.toString();
  const relative = `${parsed.pathname}${parsed.search}${parsed.hash}`;
  return url.startsWith('//') ? `//${parsed.host}${relative}` : relative;
};

// Sentry drops an event or breadcrumb when a hook returns undefined, so both
// always return their input.
export const redactEvent = (event) => {
  if (event.request?.url) {
    event.request.url = redactAuthParams(event.request.url);
  }
  if (event.request?.headers?.Referer) {
    event.request.headers.Referer = redactAuthParams(
      event.request.headers.Referer
    );
  }
  return event;
};

export const redactBreadcrumb = (breadcrumb) => {
  ['from', 'to', 'url'].forEach((key) => {
    if (breadcrumb.data?.[key]) {
      breadcrumb.data[key] = redactAuthParams(breadcrumb.data[key]);
    }
  });
  return breadcrumb;
};
